<template>
  <div id="primary-content" class="content-area">
    <CatalogHeader />
    <div class="row">
      <div class="col-xs-12">
        <div class="category-link-wrapper">
          <a v-for="item in items" :key="item.slug" class="category-link" :href="item.url">
            <span v-if="item.image" class="image-wrapper">
                <TheImage
                  :image="item.image"
                  :alt="item.name"
                  :lazy="false"
                  profile="thumb-sm"
                />
              </span>
            <CategoryIcon v-else :slug="item.slug" />
            <span v-html="item.name" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import CatalogHeader from '~/components/catalog/CatalogHeader';
import { useRankingStore } from "~/stores/ranking";

const CategoryIcon = defineAsyncComponent(() => import('~/components/icons/categories/CategoryIcon'));

const ranking = useRankingStore();

const items = computed(() => ranking.indexItems);
</script>

<style lang="scss" scoped>
.category-link-wrapper {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  max-width: 730px;

  @media (max-width: 319px) {
    flex-direction: column;
  }

  a.category-link {
    color: $black-link-color;
    display: block;
    border: 1px solid #ccc;
    border-bottom-width: 3px;
    padding: 0;
    margin-bottom: 9px;
    border-radius: 2px;
    width: 168px;
    min-height: 166px;
    margin-right: 10px;

    svg {
      display: block;
      width: 100px;
      height: 87px;
      margin: 20px auto 8px;
    }

    span {
      display: block;
      width: 110px;
      margin: 0 auto;
      text-align: center;

      &:hover {
        text-decoration: underline;
      }
    }
    span.image-wrapper {
      width: 100%;
    }

    @media (max-width: 319px) {
      margin-right: 0;
    }

    @media (min-width: 320px) and (max-width: 374px) {
      width: 140px;
      height: 138px;

      &:nth-child(odd) {
        margin-right: 10px;
      }
      &:nth-child(even) {
        margin-right: 0px;
      }

      svg {
        margin: 10px auto 8px;
        width: 83px;
        height: 72px;
      }
    }

    @media (min-width: 375px) and (max-width: 385px) {
      &:nth-child(odd) {
        margin-right: 9px;
      }
      &:nth-child(even) {
        margin-right: 0;
      }
    }
  }
}
</style>